/**
 * Practice Queue — localStorage-backed list of selected exercises.
 * Shape: { module, ids: string[], done: string[], created_at: iso }
 */
const KEY = "stenosync.practiceQueue.v1";
export const QUEUE_EVENT = "stenosync-queue-changed";

function emit() {
  try { window.dispatchEvent(new Event(QUEUE_EVENT)); } catch { /* ignore */ }
}

export function getQueue() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const q = JSON.parse(raw);
    if (!q || !Array.isArray(q.ids) || !q.module) return null;
    if (!Array.isArray(q.done)) q.done = [];
    return q;
  } catch {
    return null;
  }
}

function save(q) {
  try { localStorage.setItem(KEY, JSON.stringify(q)); } catch { /* ignore */ }
  emit();
  return q;
}

export function setQueue(module, ids) {
  return save({ module, ids: [...new Set(ids)], done: [], created_at: new Date().toISOString() });
}

export function clearQueue() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
  emit();
}

export function peekNext(module, currentId) {
  const q = getQueue();
  if (!q || q.module !== module) return null;
  const idx = q.ids.indexOf(currentId);
  if (idx === -1 || idx >= q.ids.length - 1) return null;
  return q.ids[idx + 1];
}

export function advanceQueue(module, currentId) {
  const q = getQueue();
  if (!q || q.module !== module) return null;
  const ids = q.ids.filter((x) => x !== currentId);
  if (ids.length === 0) { clearQueue(); return null; }
  return save({ ...q, ids });
}

export function markDone(module, id) {
  const q = getQueue();
  if (!q || q.module !== module || !q.ids.includes(id)) return null;
  if (!q.done.includes(id)) q.done.push(id);
  return save(q);
}

export function queueSize(module) {
  const q = getQueue();
  if (!q || q.module !== module) return 0;
  return q.ids.length;
}
